import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import update from "react-addons-update";
// styles
import style from "../../Styles/Containers/EventInput.module.css";
// component
import Header from "../../Components/Header/header";
import LogoTitle from "../../Components/LogoTitle";
import Input from "../../Components/Input";
import InputTitle from "../../Components/Input/InputTitle";
import Button from "../../Components/Button";
import Terms from "../../Components/Terms";
import CheckList from "../../Components/CheckList";
import { action } from "../../Data";
import * as Const from "../../Data/const";
import { parseUrlParameter } from "../../Lib/Utils";

class EventInputContainer extends Component {
  constructor() {
    super();
    this.state = {
      event_id: "",
      code: "",
      termList: [],
      user: {},

      btnDisabled: true
    };
    this.nameInput = React.createRef();
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitIsPossible = this.handleSubmitIsPossible.bind(this);
    this.goEventPage = this.goEventPage.bind(this);
  }
  componentDidMount() {
    let query = parseUrlParameter.parse(this.props.location.search);
    if (!query.event_id || !query.id) {
      Const.showAlert(
        Const.MESSAGE_TABLE[this.props.COUNTRY_CODE].EVENT_WRONG_ACCESS_MESSAGE
      );
      Const.userAppCloseActivity();
      return;
    }

    const loginData = this.props.eSESSION.user;

    if (!loginData) {
      Const.showAlert(Const.MESSAGE_TABLE[this.props.COUNTRY_CODE].NOT_LOGIN);
      Const.userAppCloseActivity();
      return;
    }

    this.setState({
      event_id: query.event_id,
      code: query.id,
      user: loginData,
      termList: [
        {
          title: "개인정보 제공에 동의합니다. (필수)",
          isChecked: false,
          onClick: idx => this.checkItem(idx)
        }
      ]
    });
  }

  checkItem(idx) {
    this.setState({
      termList: update(this.state.termList, {
        [idx]: {
          isChecked: { $set: !this.state.termList[idx].isChecked }
        }
      })
    });
  }

  handleChangeInput(e, option) {
    let newUser = this.state.user;

    if (option == "check") {
      newUser[e.name] = e.value;
    } else {
      newUser[e.target.name] = e.target.value;
    }

    this.setState({ user: newUser });
  }

  handleSubmit() {
    this.props
      .dispatch(action.eUSER.updateUser(this.state.user))
      .then(res => {
        this.goEventPage();
      })
      .catch(err => {
        let errData = Const.getError(err.response.data);

        Const.showAlert(errData.errMessage);
      });
  }

  handleSubmitIsPossible() {
    const user = this.state.user;
    const requiredUserVals = [
      {
        field: "name",
        validation: value => {
          return value && value.length > 0;
        },
        errMessage:
          Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]["NOT_CORRECT_NAME"]
      },
      {
        field: "year",
        validation: value => {
          return (
            Number(value) > 1900 && Number(value) <= new Date().getFullYear()
          );
        },
        errMessage:
          Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]["NOT_CORRECT_YEAR"]
      },
      {
        field: "ESex",
        validation: value => {
          return value == "man" || value == "woman";
        },
        errMessage:
          Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]["NOT_CORRECT_ESEX"]
      },
      {
        field: "email",
        validation: value => {
          return value && value.match(Const.EMAIL_REGEX);
        },
        errMessage:
          Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]["NOT_CORRECT_EMAIL"]
      }
    ];

    for (let required of requiredUserVals) {
      let value = user[required.field];

      if (!required.validation(value)) {
        return false;
      }
    }

    if (!this.state.termList[0].isChecked) {
      return false;
    }

    return true;
  }

  goEventPage() {
    this.props.history.push(
      "/user/event?event_id=" + this.state.event_id + "&id=" + this.state.code
    );
  }

  get header() {
    return (
      <Header
        onClosePress={e => {
          Const.userAppCloseActivity();
        }}
        content={"개인정보 입력"}
      />
    );
  }

  get logoTitle() {
    return (
      <LogoTitle
        logo={
          <img
            src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-win.svg"}
          ></img>
        }
        content={`계정에 등록된 개인정보가 없습니다

      이벤트 상품 수령을 위해서
      아래 정보를 입력해주세요!`}
      />
    );
  }

  get deactiveStyle() {
    return {
      color: "#fff",
      border: "solid 1px #888888",
      fontColor: "#000"
    };
  }

  render() {
    return (
      <div className={style.container} style={{ height: window.innerHeight }}>
        {this.header}
        <div className={style.contentContainer}>
          {this.logoTitle}
          <div className={style.mt24Container}>
            <InputTitle title={"이름*"}>
              <Input
                ref={this.nameInput}
                value={this.state.user.name || ""}
                onChange={e => this.handleChangeInput(e)}
                name={"name"}
              />
            </InputTitle>
          </div>
          <div className={style.inputContainer}>
            <InputTitle title={"생년*"}>
              <Input
                placeholder={"1990 (생년만 4자 입력)"}
                value={this.state.user.year || ""}
                onChange={e => this.handleChangeInput(e)}
                name={"year"}
              />
            </InputTitle>
          </div>
          <div className={style.inputContainer}>
            <InputTitle title={"성별*"}>
              <div className={style.buttonContainer}>
                <Button
                  title={"여자"}
                  {...(this.state.user.ESex === "woman"
                    ? {}
                    : this.deactiveStyle)}
                  onClick={() =>
                    this.handleChangeInput(
                      { name: "ESex", value: "woman" },
                      "check"
                    )
                  }
                />
                <div style={{ marginLeft: 8 }}></div>
                <Button
                  title={"남자"}
                  {...(this.state.user.ESex === "man"
                    ? {}
                    : this.deactiveStyle)}
                  onClick={() =>
                    this.handleChangeInput(
                      { name: "ESex", value: "man" },
                      "check"
                    )
                  }
                />
              </div>
            </InputTitle>
          </div>
          <div className={style.inputContainer}>
            <InputTitle title={"email*"}>
              <Input
                value={this.state.user.email || ""}
                onChange={e => this.handleChangeInput(e)}
                name={"email"}
              />
            </InputTitle>
          </div>
          <div className={style.inputContainer}>
            <InputTitle title={"주소"}>
              <Input
                value={this.state.user.address || ""}
                onChange={e => this.handleChangeInput(e)}
                name={"address"}
              />
            </InputTitle>
          </div>
          <div className={style.mt24Container}>
            <Terms title={"개인정보 이용 약관 보기"} />
          </div>
          <div>
            <CheckList list={this.state.termList} />
          </div>
          <div className={style.confirmContainer}>
            {this.handleSubmitIsPossible() ? (
              <Button
                title={"등록"}
                color={"#ff7d40"}
                onClick={this.handleSubmit}
              />
            ) : (
              <Button title={"등록"} color={"#bdc3c7"} />
            )}
          </div>
          <div
            className={style.bottomFont}
            onClick={() => {
              this.props.history.push(
                "/user/product?id=" + this.state.code + "&eventJoin=true"
              );
            }}
          >
            참여하지 않을래요
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    eSESSION: state.data.eSESSION.eSESSION,
    COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE
  };
})(withRouter(EventInputContainer));
